/* eslint-disable */
import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { automationHeaderLinks } from "helper/AutomationHelper/AutomationMenuLinks";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

import AlertNotification from "components/Common/AlertNotification/AlertNotification";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { postData, getData, putData } from "utils/Gateway";

import typeOptions from "data/Automation/Type.json";
import actionOptions from "data/Automation/Actions.json";
import { reactSelectStyle } from "Config/Config";

const AutomationSave = () => {
  const editor = useRef(null);

  const { t } = useTranslation(); //for translation
  // -------- breadcrumb text --------
  const breadCrumbText = [
    { title: t("Automation"), link: "/admin/automation/list" },
    { title: t("Save") },
  ];

  const commonHeaderObject = automationHeaderLinks(t);

  const params = useParams();
  const history = useHistory();
  const moduleAccess = localStorage.getItem("moduleaccess");

  const loadingCircle = [1, 2, 3, 4, 5, 6];

  const token = localStorage.getItem("token");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  // states
  const [tagOptions, setTagOptions] = useState([]); // State to store filtered tag options
  const [usersInput, setUsersInput] = useState(""); // State for followers input
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [messageTemplates, setMessageTemplates] = useState([]); // mail template options (without link tracker labels)
  const [taskTemplates, setTaskTemplates] = useState([]);
  const [moduleOptions, setModuleOptions] = useState([]);

  const [mailTemplateList, setMailTemplateList] = useState([]); // mail templates with link tracker labels
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [linkTrackerLabel, setLinkTrackerLabel] = useState("");

  const [myAutomation, setMyAutomation] = useState([]);

  const [linkTrackerOptions, setLinkTrackerOptions] = useState([]);

  const [isSaving, setIsSaving] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const [isActive, setIsActive] = useState(true); // New state for active/inactive
  const [isLoading, setIsLoading] = useState(false); // Loading state for details

  const validationHandler = () => {
    let isValid = true;

    return isValid;
  };

  const [name, setName] = useState(""); // Automation name

  const [trigger, setTrigger] = useState({
    module: null,
    type: null,
    mailtemplate: null,
    value: "",
  });
  const [steps, setSteps] = useState([
    { action: "", duration: 0, parameters: "" },
  ]);

  const [errors, setErrors] = useState({
    trigger: { module: false, type: false, value: false },
    steps: false,
  });

  // JSON VALUES FOR SELECT OPTIONS ===============================

  // Modules to be used in automation
  const moduleSlugs = ["MOD_LEAD", "MOD_CONTACT", "MOD_USER"];
  const moduleSlugsString = moduleSlugs.join(",");

  // function to get module options
  const getModulesBySlug = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_MODULES_BY_SLUG +
        `?slugs=${moduleSlugsString}`;

      const response = await getData(requestUrl);

      console.log("Modules Response:", response);

      const moduleSelectOptions = [];
      if (response.status) {
        response.data.forEach((module) => {
          moduleSelectOptions.push({
            value: module._id,
            label: module.name,
          });
        });
        setModuleOptions(moduleSelectOptions);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // steps status options
  const statusOptions = [
    { value: "1", label: "Enable" },
    { value: "0", label: "Disable" },
  ];

  // functions to get data ================
  //function for get all tags
  const getAllTags = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_TAGS;

      const response = await getData(requestUrl);

      console.log("Tags Response:", response);

      if (response.status) {
        setTagOptions(response.data); // Initialize tag options with all tags
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //function for get users list
  const getUsersList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?userstringinput=${usersInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setAssignedUsers(response.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  //function for get followers input
  const usersInputHandler = (val) => {
    setUsersInput(val);
  };

  //function for get all mail templates
  const getAllMailTemplates = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_TEMPLATE_LIST;

      const response = await getData(requestUrl);

      console.log("Mail Templates Response:", response);

      if (response.status) {
        // Update label to: {template.name} Labels - {count}
        const apiData = response.data.reduce((acc, template) => {
          if (template.linktrackerids && template.linktrackerids.length > 0) {
            acc.push({
              ...template,
              label: `${template.label} (Labels - ${template.linktrackerids.length})`,
              value: template._id ? template._id.toString() : "",
            });
          }
          return acc;
        }, []);
        console.log("Filtered Templates:", apiData);
        setMailTemplateList(apiData);

        // update MessageTemplates
        const messageTemplates = response.data.map((template) => ({
          value: template.value,
          label: template.label,
        }));
        setMessageTemplates(messageTemplates);
      }
    } catch (error) {
      console.log(error.message);
    }
  };


  // get all my automations
  const getMyAutomations = async () => {
    try {
      let requestUrl =
            url.API_BASE_URL + url.API_AUTOMATION_CONFIG;

      const response = await getData(requestUrl);

      console.log("My Automations Response:", response);

      if (response.status) {
        const automationOptions = response.data.map((automation) => ({
          value: automation._id,
          label: automation.name,
        }));
        setMyAutomation(automationOptions);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // mail template select handler
  const handleMailTemplateChange = (selectedOption) => {
    if (!selectedOption) {
      // Clear selection
      setSelectedTemplate(null);
      setTrigger((prev) => ({ ...prev, mailtemplate: null, value: "" }));
      setLinkTrackerOptions([]);
      return;
    }
    setSelectedTemplate(selectedOption.value);

    // Always reset value when mail template changes
    setTrigger((prev) => ({
      ...prev,
      mailtemplate: selectedOption.value,
      value: "",
    }));

    // Find the selected template object
    const templateObj = mailTemplateList.find(
      (t) => t.value === selectedOption.value
    );

    if (templateObj) {
      // Get link tracker labels from the selected template
      getLinkTrackerLabels(templateObj);
    } else {
      setLinkTrackerOptions([]);
    }
  };

  const getLinkTrackerLabels = async (templateObj) => {
    if (templateObj && Array.isArray(templateObj.linktrackerids)) {
      console.log("Selected Template:", templateObj.linktrackerids);

      const linkTrackerOptions = templateObj.linktrackerids.map((id, idx) => ({
        label: id.label,
        value: id._id ? id._id.toString() : `linktracker-${idx + 1}`,
      }));

      console.log("LinkTracker Options:", linkTrackerOptions);

      setLinkTrackerOptions(linkTrackerOptions);
    } else {
      setLinkTrackerOptions([]);
    }
  };

  const handleTriggerChange = (field, value) => {
    console.log("Trigger Change:", field, value);

    // If type is changed, reset mailtemplate and value if needed
    if (field === "type") {
      let reset = { mailtemplate: null, value: "" };
      setSelectedTemplate(null);
      setLinkTrackerOptions([]);

      setTrigger((prev) => ({ ...prev, [field]: value, ...reset }));
    } else {
      setTrigger((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleStepChange = (index, field, value) => {
    const updatedSteps = [...steps];
    updatedSteps[index][field] = value;

    console.log("Updated Steps:", updatedSteps);

    setSteps(updatedSteps);
  };

  // Function to map selected tag value from tagOptions
  const getSelectedTag = (value) => {
    return tagOptions.find((tag) => tag.value === value) || null;
  };

  const handleWaitDurationChange = (index, field, value) => {
    const updatedSteps = [...steps];
    if (field === "days") {
      const minutes = value * 24 * 60; // Convert days to minutes
      updatedSteps[index].duration = minutes;
    } else if (field === "minutes") {
      updatedSteps[index].duration = value;
    }
    setSteps(updatedSteps);
  };

  //function for automation details
  const getAutomationDetails = async () => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_AUTOMATION_CONFIG_DETAILS +
        `/${params.id}`;

      console.log("Automation Details Request URL:", requestUrl);

      const response = await getData(requestUrl);

      console.log("Automation Details Response:", response);

      if (response.status) {
        const automationData = response.data;

        // Set automation name
        setName(automationData.name || "");

        // Set trigger data
        setTrigger({
          module: automationData.trigger.module
            ? automationData.trigger.module._id
            : null,
          type: automationData.trigger.type,
          value: automationData.trigger.value || "",
          mailtemplate: automationData.trigger.messagetemplate
            ? automationData.trigger.messagetemplate
            : null,
        });

        // Set steps data
        const updatedSteps = automationData.steps.map((step) => ({
          action: step.action,
          duration: step.duration || 0,
          parameters: step.parameters || "",
        }));

        setSteps(updatedSteps);

        // set mail template if present
        if (automationData.trigger.messagetemplate) {
          setSelectedTemplate(automationData.trigger.messagetemplate._id);

          // Get link tracker labels from the selected template
          getLinkTrackerLabels(automationData.trigger.messagetemplate);
        }

        // Set isActive if present, default to true
        setIsActive(
          typeof automationData.isactive === "boolean"
            ? automationData.isactive
            : true
        );
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error.message);
      setIsLoading(false);
    }
  };

  //function for save automation
  const saveAutomationHandler = async () => {
    const newErrors = {
      trigger: {
        module: !trigger.module,
        type: !trigger.type,
        value: !trigger.value, // Ensure value is required
      },
      steps: steps.length === 0 || steps.every((step) => !step.action),
    };

    setErrors(newErrors);

    if (
      Object.values(newErrors.trigger).some((error) => error) ||
      newErrors.steps
    ) {
      return;
    }

    if (validationHandler()) {
      try {
        setIsSaving(true);

        console.log("Trigger Data:", trigger);
        console.log("Steps Data:", steps);

        const data = {
          name,
          trigger,
          steps,
          isactive: isActive, // Include isActive in payload
        };

        let response = {};

        if (params.id) {
          let requestUrl =
            url.API_BASE_URL +
            url.API_AUTOMATION_CONFIG +
            `/${params.id}`;

          response = await putData(requestUrl, data);

          console.log("Update Automation Response:", response);

          if (response.status) {
            setAlertMessage("Automation data saved successfully.");
            setMessageType("success");
            setShowAlert(true);
          } else {
            setAlertMessage("Failed to save automation data.");
            setMessageType("error");
            setShowAlert(true);
          }
        } else {
          let requestUrl =
            url.API_BASE_URL + url.API_AUTOMATION_CONFIG;

          response = await postData(requestUrl, data);

          if (response.status) {
            setAlertMessage("Automation data saved successfully.");
            setMessageType("success");
            setShowAlert(true);
          } else {
            setAlertMessage("Failed to save automation data.");
            setMessageType("error");
            setShowAlert(true);
          }
        }

        setIsSaving(false);

        console.log(response);
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  // Function to add a new step
  const addStep = () => {
    setSteps((prevSteps) => [
      ...prevSteps,
      {
        action: "",
        duration: 0,
        parameters: "",
      },
    ]);
  };

  // Function to remove a step
  const removeStep = (index) => {
    setSteps((prevSteps) => prevSteps.filter((_, i) => i !== index));
  };

  // Reorder function for drag-and-drop
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  // Handle drag-and-drop end
  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedSteps = reorder(
      steps,
      result.source.index,
      result.destination.index
    );
    setSteps(reorderedSteps);
  };

  
  useEffect(() => {
    if (params.id) {
      getAutomationDetails();
    }
  }, [params.id]);

  // Fetch initial data
  useEffect(() => {
    getAllTags();
    getAllMailTemplates();
    getModulesBySlug();
    getMyAutomations();
  }, []);

  // users input state
  useEffect(() => {
    if (usersInput.length > 0) {
      getUsersList();
    }
  }, [usersInput]);

  /* Closes the alert by updating the state variables.*/
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (isLoading) {
    return (
      <div id="content_wrapper">
        <section className="event-details-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Automation Config")}
          />
          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            {/* -------- bread crumb ---------- */}
            <BreadCrumb breadCrumbText={breadCrumbText} bottom={true} />

            {/* Automation Status Placeholder */}
            <div
              className="mb-3"
              style={{
                height: "48px",
                borderRadius: "10px",
                background:
                  "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)",
                backgroundSize: "400% 100%",
                animation: "glowPlaceholder 1.4s ease infinite",
              }}
            />
            {/* Trigger Section Placeholder */}
            <div
              className="mb-4"
              style={{
                height: "120px",
                borderRadius: "10px",
                background:
                  "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)",
                backgroundSize: "400% 100%",
                animation: "glowPlaceholder 1.4s ease infinite",
              }}
            />
            {/* Steps/Actions Section Placeholder */}
            <div
              style={{
                height: "220px",
                borderRadius: "10px",
                background:
                  "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)",
                backgroundSize: "400% 100%",
                animation: "glowPlaceholder 1.4s ease infinite",
              }}
            />
          </div>
          <style>
            {`
              @keyframes glowPlaceholder {
                0% {
                  background-position: 100% 50%;
                }
                100% {
                  background-position: 0 50%;
                }
              }
            `}
          </style>
        </section>
      </div>
    );
  }

  if (userInfo.role.slug === "ADMIN" || userInfo.role.slug === "SUPER_ADMIN") {
    return (
      <div id="content_wrapper">
        <section className="event-details-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Automation Config")}
          />

          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            {/* -------- bread crumb ---------- */}
            <BreadCrumb breadCrumbText={breadCrumbText} bottom={true} />

            {/* --- Active/Inactive Switch Row ----- */}
            <div className="row mb-3">
              <div className="col-12 d-flex align-items-center">
                <span className="fw-semibold me-3">
                  {t("Automation Status")}:
                </span>
                <div
                  className="form-check form-switch"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    minHeight: "32px",
                  }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="automationActiveSwitch"
                    checked={isActive}
                    onChange={() => setIsActive((prev) => !prev)}
                    style={{
                      width: "48px",
                      height: "24px",
                      backgroundColor: isActive ? "#28a745" : "#adb5bd",
                      borderColor: isActive ? "#28a745" : "#adb5bd",
                      boxShadow: "none",
                      cursor: "pointer",
                    }}
                  />
                  <label
                    className="form-check-label ms-2 fw-semibold"
                    htmlFor="automationActiveSwitch"
                    style={{
                      color: isActive ? "#28a745" : "#6c757d",
                      fontWeight: 600,
                      fontSize: "1rem",
                    }}
                  >
                    {isActive ? t("Active") : t("Inactive")}
                  </label>
                </div>
              </div>
            </div>

            {/* --- Trigger Section ----- */}
            <div className="p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm mb-4">
              <form onSubmit={(e) => e.preventDefault()}>

                {/* Name Input */}
                <div className="form-group mb-3">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    {t("Automation Name")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={name}
                    maxLength={20}
                    onChange={(e) => setName(e.target.value)}
                    placeholder={t("Enter Name (Max 20 characters)")}
                    required
                  />
                  {name === "" && (
                    <small className="text-danger">
                      {t("Automation Name is required.")}
                    </small>
                  )}
                </div>

                {/* Trigger Section */}
                <div className="form-group mb-3">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    {t("Trigger")}
                  </label>
                  <div className="row">
                    <div className="col-lg-4">
                      <label className="d-block fs-sm fw-semibold mb-2">
                        {t("Module")}
                      </label>
                      <Select
                        styles={reactSelectStyle("3px", "6px", true, false)}
                        options={moduleOptions}
                        value={
                          moduleOptions.length > 0 &&
                          trigger.module &&
                          moduleOptions.find(
                            (opt) => opt.value === trigger.module
                          )
                        }
                        onChange={(val) =>
                          handleTriggerChange("module", val.value)
                        }
                        placeholder={t("Select Module")}
                      />
                      {errors.trigger.module && (
                        <small className="text-danger">
                          {t("Module is required.")}
                        </small>
                      )}
                    </div>
                    
                    <div className="col-lg-4">
                      <label className="d-block fs-sm fw-semibold mb-2">
                        {t("Type")}
                      </label>
                      <Select
                        styles={reactSelectStyle("3px", "6px", true, false)}
                        options={typeOptions}
                        value={
                          typeOptions.length > 0 &&
                          trigger.type &&
                          typeOptions.find((opt) => opt.value === trigger.type)
                        }
                        onChange={(val) =>
                          handleTriggerChange("type", val.value)
                        }
                        placeholder={t("Select Type")}
                      />
                      {errors.trigger.type && (
                        <small className="text-danger">
                          {t("Type is required.")}
                        </small>
                      )}
                    </div>

                    {/* Show Template select only if type is mail_linktracker_label_added */}
                    {trigger.type === "mail_linktracker_label_added" && (
                      <div className="col-lg-4">
                        <label className="d-block fs-sm fw-semibold mb-2">
                          {t("Template")}
                        </label>
                        <Select
                          styles={reactSelectStyle("3px", "6px", true, false)}
                          options={mailTemplateList}
                          value={
                            mailTemplateList.length > 0 &&
                            selectedTemplate &&
                            mailTemplateList.find(
                              (opt) => opt.value === selectedTemplate
                            )
                          }
                          onChange={handleMailTemplateChange}
                          placeholder={t("Select Template")}
                          isClearable={true}
                        />
                        {errors.trigger.template && (
                          <small className="text-danger">
                            {t("Template is required.")}
                          </small>
                        )}
                      </div>
                    )}

                    {trigger.type !== "" && (
                      <div className="col-lg-4">
                        <label className="d-block fs-sm fw-semibold mb-2">
                          {t("Value")}
                        </label>
                        <Select
                          styles={reactSelectStyle("3px", "6px", true, false)}
                          options={
                            trigger.type === "mail_linktracker_label_added"
                              ? linkTrackerOptions
                              : tagOptions
                          }
                          value={
                            trigger.type === "mail_linktracker_label_added"
                              ? linkTrackerOptions.find(
                                  (opt) => opt.value === trigger.value
                                )
                              : tagOptions.length > 0 && trigger.value
                              ? getSelectedTag(trigger.value)
                              : null
                          }
                          onChange={(val) =>
                            handleTriggerChange("value", val.value)
                          }
                          placeholder={
                            trigger.type === "mail_linktracker_label_added"
                              ? t("Select LinkTracker")
                              : t("Search and Select Tag")
                          }
                        />
                        {errors.trigger.value && (
                          <small className="text-danger">
                            {t("Value is required.")}
                          </small>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>

            {/* --- Steps Section ----- */}
            <div className="p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
              <label className="d-block fs-sm fw-semibold mb-2">
                {t("Steps / Actions")}
              </label>
              {errors.steps && (
                <small className="text-danger d-block mb-2">
                  {t("At least select 1 step with an action.")}
                </small>
              )}
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="steps">
                  {(provided) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={{ marginTop: "10px" }}
                    >
                      {steps.map((step, index) => (
                        <Draggable
                          key={index}
                          draggableId={`step-${index}`}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                padding: "16px",
                                marginBottom: "8px",
                                borderRadius: "8px",
                                border: "1px solid #ddd",
                                ...provided.draggableProps.style,
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center mb-3 bg-light p-1">
                                <div className="d-flex align-items-center gap-2">
                                  <span
                                    {...provided.dragHandleProps}
                                    className="material-symbols-outlined text-primary"
                                    style={{ cursor: "grab", fontSize: "24px" }}
                                  >
                                    drag_indicator
                                  </span>
                                  <span className="fs-sm fw-semibold text-primary">
                                    {t(`STEP : ${index + 1}`)}
                                  </span>
                                </div>
                                <Link
                                  to="#"
                                  className="text-danger"
                                  onClick={() => removeStep(index)}
                                >
                                  <span className="material-symbols-outlined">
                                    delete
                                  </span>
                                </Link>
                              </div>
                              <div className="row">
                                <div className="col-lg-3">
                                  <label className="d-block fs-sm fw-semibold mb-2">
                                    {t("Action")}
                                  </label>
                                  <Select
                                    styles={reactSelectStyle(
                                      "3px",
                                      "6px",
                                      true,
                                      false
                                    )}
                                    options={actionOptions}
                                    value={actionOptions.find(
                                      (opt) => opt.value === step.action
                                    )}
                                    onChange={(val) =>
                                      handleStepChange(
                                        index,
                                        "action",
                                        val.value
                                      )
                                    }
                                    placeholder={t("Select Action")}
                                  />
                                </div>

                                {/* add remove tag *********************** */}
                                {(step.action === "add_tag" ||
                                  step.action === "remove_tag") && (
                                  <div className="col-lg-3">
                                    <label className="d-block fs-sm fw-semibold mb-2">
                                      {t("Select Tag")}
                                    </label>
                                    <Select
                                      styles={reactSelectStyle(
                                        "3px",
                                        "6px",
                                        true,
                                        false
                                      )}
                                      options={tagOptions}
                                      value={
                                        tagOptions.length > 0 &&
                                        step.parameters &&
                                        tagOptions.find(
                                          (tag) => tag.value === step.parameters
                                        )
                                      }
                                      onChange={(val) =>
                                        handleStepChange(
                                          index,
                                          "parameters",
                                          val.value
                                        )
                                      }
                                      placeholder={t("Search and Select Tag")}
                                    />
                                  </div>
                                )}

                                {/* Wait Action  **************************** */}
                                {step.action === "wait" && (
                                  <>
                                    <div className="col-lg-3">
                                      <label className="d-block fs-sm fw-semibold mb-2">
                                        {t("Wait Duration (days) Optional")}
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control fs-sm shadow-none"
                                        placeholder={t("Enter Days")}
                                        onChange={(e) =>
                                          handleWaitDurationChange(
                                            index,
                                            "days",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="col-lg-3">
                                      <label className="d-block fs-sm fw-semibold mb-2">
                                        {t("Wait Duration (minutes)")}
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control fs-sm shadow-none"
                                        value={step.duration}
                                        placeholder={t("Enter Minutes")}
                                        min={1}
                                        onChange={(e) =>
                                          handleWaitDurationChange(
                                            index,
                                            "minutes",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                )}

                                {/* send mail **************************** */}
                                {step.action === "send_email" && (
                                  <div className="col-lg-3">
                                    <label className="d-block fs-sm fw-semibold mb-2">
                                      {t("Select Message Template")}
                                    </label>
                                    <Select
                                      styles={reactSelectStyle(
                                        "3px",
                                        "6px",
                                        true,
                                        false
                                      )}
                                      options={messageTemplates} // Replace with message template options
                                      value={
                                        messageTemplates.length > 0 &&
                                        step.parameters &&
                                        messageTemplates.find(
                                          (template) =>
                                            template.value === step.parameters
                                        )
                                      }
                                      onChange={(val) =>
                                        handleStepChange(
                                          index,
                                          "parameters",
                                          val.value
                                        )
                                      }
                                      placeholder={t("Select Template")}
                                    />
                                  </div>
                                )}

                                {/* Create Task  **************************** */}
                                {step.action === "create_task" && (
                                  <div className="col-lg-3">
                                    <label className="d-block fs-sm fw-semibold mb-2">
                                      {t("Task Template")}
                                    </label>
                                    <Select
                                      styles={reactSelectStyle(
                                        "3px",
                                        "6px",
                                        true,
                                        false
                                      )}
                                      options={[]} // Replace with task template options
                                      //value={step.parameters ? taskTemplates.find(template => template.value === step.parameters) : null}
                                      onChange={(val) =>
                                        handleStepChange(
                                          index,
                                          "parameters",
                                          val.value
                                        )
                                      }
                                      placeholder={t("Select Task Template")}
                                    />
                                  </div>
                                )}

                                {/* Send Notification  **************************** */}
                                {step.action === "send_notification" && (
                                  <div className="col-lg-3">
                                    <label className="d-block fs-sm fw-semibold mb-2">
                                      {t("Notification Mail Template")}
                                    </label>
                                    <Select
                                      styles={reactSelectStyle(
                                        "3px",
                                        "6px",
                                        true,
                                        false
                                      )}
                                      options={[]} // Replace with notification template options
                                      value={
                                        messageTemplates.length > 0 &&
                                        step.parameters &&
                                        messageTemplates.find(
                                          (template) =>
                                            template.value === step.parameters
                                        )
                                      }
                                      onChange={(val) =>
                                        handleStepChange(
                                          index,
                                          "parameters",
                                          val.value
                                        )
                                      }
                                      placeholder={t("Select Mail Template")}
                                    />
                                  </div>
                                )}

                                {/* Assign User  **************************** */}
                                {step.action === "assign_user" && (
                                  <div className="col-lg-3">
                                    <label className="d-block fs-sm fw-semibold mb-2">
                                      {t("Select Contact")}
                                    </label>
                                    <Select
                                      styles={reactSelectStyle(
                                        "3px",
                                        "6px",
                                        true,
                                        false
                                      )}
                                      options={assignedUsers} // Replace with user options
                                      value={
                                        assignedUsers.length > 0 &&
                                        step.parameters &&
                                        assignedUsers.find(
                                          (user) =>
                                            user.value === step.parameters
                                        )
                                      }
                                      onChange={(val) =>
                                        handleStepChange(
                                          index,
                                          "parameters",
                                          val.value
                                        )
                                      }
                                      placeholder={t("Select User")}
                                      onInputChange={(val) => {
                                        usersInputHandler(val);
                                      }}
                                    />
                                  </div>
                                )}

                                {/* Trigger Webhook  **************************** */}
                                {step.action === "trigger_webhook" && (
                                  <div className="col-lg-3">
                                    <label className="d-block fs-sm fw-semibold mb-2">
                                      {t("Webhook URL")}
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control fs-sm shadow-none"
                                      value={step.parameters || ""}
                                      onChange={(e) =>
                                        handleStepChange(
                                          index,
                                          "parameters",
                                          e.target.value
                                        )
                                      }
                                      placeholder={t("Enter Webhook URL")}
                                    />
                                  </div>
                                )}

                                {/* Change Status  **************************** */}
                                {step.action === "change_status" && (
                                  <div className="col-lg-3">
                                    <label className="d-block fs-sm fw-semibold mb-2">
                                      {t("Select Status")}
                                    </label>
                                    <Select
                                      styles={reactSelectStyle(
                                        "3px",
                                        "6px",
                                        true,
                                        false
                                      )}
                                      options={statusOptions}
                                      value={statusOptions.find(
                                        (opt) => opt.value === step.parameters
                                      )}
                                      onChange={(val) =>
                                        handleStepChange(
                                          index,
                                          "parameters",
                                          val.value
                                        )
                                      }
                                      placeholder={t(
                                        "Select Enable or Disable"
                                      )}
                                    />
                                  </div>
                                )}

                                {/* Stop Automation  **************************** */}
                                {step.action === "stop_automation" && (
                                  <div className="col-lg-3">
                                    <label className="d-block fs-sm fw-semibold mb-2">
                                      {t("Select Automation")}
                                    </label>
                                    <Select
                                      styles={reactSelectStyle(
                                        "3px",
                                        "6px",
                                        true,
                                        false
                                      )}
                                      options={myAutomation}
                                      value={myAutomation.find(
                                        (opt) => opt.value === step.parameters
                                      )}
                                      onChange={(val) =>
                                        handleStepChange(
                                          index,
                                          "parameters",
                                          val.value
                                        )
                                      }
                                      placeholder={t(
                                        "Select Automation to disable"
                                      )}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary mt-3"
                onClick={addStep}
              >
                {t("Add Step")}
              </button>
            </div>

            {/* --- Save Button ----- */}
            <div className="action d-flex flex-wrap gap-3 align-items-center justify-content-end mt-4">
              <button
                type="button"
                className="btn btn-primary"
                style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                disabled={isSaving ? true : false}
                onClick={saveAutomationHandler}
              >
                {t("Save Automation")}
                {isSaving && (
                  <div
                    className="mx-2 spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </button>
            </div>
          </div>

          {/* --- Alert Message ----- */}
          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default AutomationSave;
